<p-panel [toggleable]="true" [collapsed]="shouldBeCollapsed">
  <ng-template #header
    ><div>
      <i class="fa-solid fa-table-cells-large mr-3"></i>BMS Info
    </div></ng-template
  >
  <p-table
    showGridlines="true"
    stripedRows
    size="small"
    [loading]="isLoading()"
    [value]="BMSList()"
  >
    <ng-template #header>
      <tr>
        <th class="lg:w-1/10 xl:w-1/12 2xl:w-1/14 3xl:w-1/16">
          <div class="text-center">
            <span class="hidden lg:inline">Status</span>
          </div>
        </th>
        <th>Name</th>
        <th>Last Update</th>
        <th>Fault</th>
        <th>Temperature (℃)</th>
        <th>SoC</th>
      </tr>
    </ng-template>
    <ng-template #body let-bms>
      <tr>
        <td
          [style]="
            iconsStyles.getDeviceStatusBackgroundStyle(
              customFunctions.getDeviceStatus(bms.available, bms.error)
            )
          "
        >
          <div class="text-center">
            <i
              [class]="
                iconsStyles.getDeviceStatusIcon(
                  customFunctions.getDeviceStatus(bms.available, bms.error)
                )
              "
              class="lg:mr-2"
            ></i
            ><span class="hidden lg:inline">{{
              customFunctions.getDeviceStatus(bms.available, bms.error)
            }}</span>
          </div>
        </td>
        <td>BMS {{ bms.devNo }}</td>
        <td>
          <span class="hidden lg:inline">
            {{ bms.lastUpdate | date : "dd-MM-yyyy, HH:mm" }} </span
          ><span class="lg:hidden">
            {{ bms.lastUpdate | date : "dd-MM, HH:mm" }}
          </span>
        </td>
        <td>
          @if(bms.fault === 0) {-} @else {<i
            class="pi pi-exclamation-triangle"
            style="color: red"
          ></i
          >}
        </td>
        <td>{{ bms.T }}</td>
        <td>
          <i
            [class]="iconsStyles.getStateOfChargeIcon(bms.SoC)"
            class="mr-2"
          ></i
          >{{ bms.SoC }}%
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-panel>
